"use client"

const ExistingHoldItemsSection = ({ existingItems, onUpdateQuantity }) => {
  if (!existingItems || existingItems.length === 0) {
    return null
  }

  return (
    <div className="bg-gray-50 p-3 rounded-lg mb-3 border border-gray-200">
      <div className="mb-2">
        <h3 className="text-lg font-bold text-gray-800">Current Hold Bill Items</h3>
        <p className="text-sm text-gray-600">You can modify quantities or add new items below</p>
      </div>

      <div className="flex overflow-x-auto pb-2 gap-3">
        {existingItems.map((item, index) => (
          <div
            key={index}
            className="bg-white rounded-lg p-3 border border-gray-200 min-w-[150px] h-[180px] flex flex-col justify-between relative"
          >
            <div
              className={`w-3 h-3 rounded-full absolute top-3 right-3 ${
                item.category === "Veg" ? "bg-green-600" : "bg-red-600"
              }`}
            />

            <div className="line-clamp-2 font-bold text-gray-800 text-sm mb-1">
              {item.itemName}
              {item.selectedVariant ? ` (${item.selectedVariant.name})` : ""}
            </div>

            <div className="text-gray-700 text-sm">
              ₹{item.price} x {item.quantity || 1}
            </div>

            {item.names && <div className="text-xs text-gray-500 italic mt-1 truncate">{item.names}</div>}

            <div className="flex items-center justify-center mt-2 pt-2 border-t border-gray-100">
              <button
                onClick={() => onUpdateQuantity(item, -1)}
                className="w-8 h-8 flex items-center justify-center bg-red-500 text-white rounded-full"
              >
                -
              </button>
              <span className="mx-3 font-semibold">{item.quantity || 1}</span>
              <button
                onClick={() => onUpdateQuantity(item, 1)}
                className="w-8 h-8 flex items-center justify-center bg-blue-500 text-white rounded-full"
              >
                +
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default ExistingHoldItemsSection
